module.exports = __webpack_public_path__ + "static/homlan-logo-027d12b9057ae3f8c081275f4e59fe98.jpg";